export const RATIO_META = [
    { key: 'liquidezCorriente', group: 'balance', format: 'ratio', drilldownKeys: ['AC', 'PC'] },
    { key: 'pruebaAcida', group: 'balance', format: 'ratio', drilldownKeys: ['AC', 'EX', 'PC'] },
    { key: 'fondoManiobra', group: 'balance', format: 'cents', drilldownKeys: ['AC', 'PC'] },
    { key: 'endeudamiento', group: 'balance', format: 'ratio', drilldownKeys: ['PC', 'PNC', 'PN'] },
    { key: 'calidadDeuda', group: 'balance', format: 'ratio', drilldownKeys: ['DFC', 'PNC'] },
    { key: 'margenBrutoPct', group: 'pnl', format: 'pct', drilldownKeys: ['ING', 'CMV'] },
    {
        key: 'ebitdaMarginPct',
        group: 'pnl',
        format: 'pct',
        drilldownKeys: ['ING', 'CMV', 'GP', 'GOP'],
    },
    {
        key: 'netMarginPct',
        group: 'pnl',
        format: 'pct',
        drilldownKeys: ['ING', 'CMV', 'GP', 'GOP', 'DA', 'GFI', 'OTR', 'IMP'],
    },
    { key: 'salesGrowthMoM', group: 'pnl', format: 'pct', drilldownKeys: ['ING'] },
    { key: 'salesGrowthYoY', group: 'pnl', format: 'pct', drilldownKeys: ['ING'] },
];
/**
 * La prueba ácida solo se enseña si hay existencias que descontar: sin ellas su numerador es el de
 * la liquidez corriente y la tarjeta repetiría el mismo número con otro semáforo (el MISMO valor
 * saldría en verde arriba y en rojo al lado). Lo decide quien arma la lista, con `EX`.
 */
export function ratioMetaFor(group, hasStock) {
    return RATIO_META.filter((m) => m.group === group && (m.key !== 'pruebaAcida' || hasStock));
}
//# sourceMappingURL=ratio-meta.js.map